/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type careTeam_PlanCareTeam$ref: FragmentReference;
declare export opaque type careTeam_PlanCareTeam$fragmentType: careTeam_PlanCareTeam$ref;
export type careTeam_PlanCareTeam = {|
  +id: string,
  +careTeamMembers: $ReadOnlyArray<?{|
    +id: string,
    +name: ?string,
    +primary: ?boolean,
    +role: {|
      +id: string,
      +code: ?string,
      +value: ?string,
    |},
  |}>,
  +$refType: careTeam_PlanCareTeam$ref,
|};
export type careTeam_PlanCareTeam$data = careTeam_PlanCareTeam;
export type careTeam_PlanCareTeam$key = {
  +$data?: careTeam_PlanCareTeam$data,
  +$fragmentRefs: careTeam_PlanCareTeam$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "careTeam_PlanCareTeam",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CareTeamMember",
      "kind": "LinkedField",
      "name": "careTeamMembers",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CodeTablePair",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Plan",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e4d254cf3abb57d5838e5eb8b430819b';

module.exports = node;
